import {parseArrivals, isNormal} from '../helpers/bus-arrival';
import Panel from './panel';

// 다시 부르는 주기(ms). 도착정보는 nginx 가 25초 캐시하므로 이보다 짧게 잡아도
// 상류 호출은 안 늘고 화면만 같은 값을 다시 그린다.
const REFRESH_MS = 30000;

function busHTML({text, sub, notes}) {
    return [
        '<div class="busstop-row">',
        `<div class="busstop-title-box"><div class="desc-small">${notes}</div></div>`,
        `<div class="busstop-time-box">${text}`,
        sub ? `<div class="desc-small">${sub}</div>` : '',
        '</div></div>'
    ].join('');
}

function routeHTML({route, buses}) {
    return [
        '<div class="arrival-route">',
        `<span class="bus-route-label">${route}</span>`,
        buses.length ?
            buses.map(busHTML).join('') :
            '<div class="busstop-row"><div class="busstop-title-box desc-small">예정 차량 없음</div></div>',
        '</div>'
    ].join('');
}

export default class extends Panel {

    constructor(options) {
        super(Object.assign({className: 'bus-panel'}, options));
    }

    addTo(map) {
        const me = this,
            {name, code} = me._options;

        super.addTo(map);
        me.setTitle([
            '<div class="desc-header">',
            '<div style="background-color: #3D5BAB;"></div>',
            '<div><div class="desc-first-row">',
            name,
            '<span class="realtime-icon"></span>',
            '</div><div class="desc-second-row">도착예정</div></div></div>'
        ].join(''));
        me.setHTML('<div class="desc-small">불러오는 중…</div>');

        // 도착정보는 열려 있는 동안 계속 늙는다. '3분 후' 를 그대로 두면 3분 뒤에는
        // 틀린 화면인데 틀려 보이지 않는다.
        me._refresh(code);
        me._timer = setInterval(() => me._refresh(code), REFRESH_MS);

        return me;
    }

    _refresh(code) {
        const me = this,
            // stop_code 는 `제공자:번호` 다 (`seoul:10001` · `gbis:203000061`).
            // 제공자마다 API·응답 모양이 달라 프록시 경로도 갈라져 있다.
            [src, id] = String(code || '').split(':');

        // 번호가 없는 정류장(가상 정류소 등)은 부를 곳이 없다. 조용히 빈 화면을
        // 주지 말고 왜 없는지 적는다 - 이게 없으면 '고장' 으로 읽힌다.
        if (!src || !id) {
            me.setHTML('<div class="desc-small">이 정류장은 도착정보를 제공하지 않습니다.</div>');
            return;
        }

        fetch(`/api/arrival/${src}?id=${encodeURIComponent(id)}`).then(response => {
            if (!response.ok) {
                throw new Error(response.status);
            }
            return response.json();
        }).then(json => {
            if (!me._container) {
                return;
            }
            if (!isNormal(src, json)) {
                me.setHTML('<div class="desc-small">도착정보를 가져오지 못했습니다.</div>');
                return;
            }

            const routes = parseArrivals(src, json);

            me.setHTML(routes.length ?
                routes.map(routeHTML).join('') :
                '<div class="desc-small">이 정류장에 등록된 노선이 없습니다.</div>');
        }).catch(() => {
            if (me._container) {
                me.setHTML('<div class="desc-small">도착정보를 가져오지 못했습니다.</div>');
            }
        });
    }

    remove() {
        clearInterval(this._timer);
        return super.remove();
    }

}
